import { styled } from '@mui/material/styles'

export const AppWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  flex: 'auto',
}))

export const MainContent = styled('main')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 'auto',
  overflow: 'auto',
  backgroundColor: theme.palette.grey[100],
}))

export const brandLogoStyles = {
  height: '58px',
  width: '150px',
}
